module.exports = __webpack_public_path__ + "assets/media/cities-about.02d48b80.svg";